<template>
  <div>
    <div class="currency currency_same">
        <div class="header"><span class="hText">通用参数</span></div>
        <div class="content">
            <div class="blockItem">
                <div class="item_type">
                    <div class="itemLeft" title="
                    单位：m，0表示压路机刚好压到左边线，
正数表示压路机向道路内方向空出指定值的间隙不压，
负数表示压路机向道路左边线以外方向多压指定值的宽度。

                    ">左边道路间隙</div>
                    <div class="itemRight">
                        <div class='companyShow'>M</div>
                        <el-input v-if="isLook" class="infoShow" v-model="workSetInfoValue.normalParam.leftGap.value"></el-input>
                        <span v-if="!isLook" class="infoShow">{{workSetInfoValue.normalParam.leftGap.value}}</span>
                    </div>
                </div>
                <div class="item_type">
                    <div class="itemLeft" title="
                    单位：m，0表示压路机刚好压到左边线，
正数表示压路机向道路内方向空出指定值的间隙不压，
负数表示压路机向道路左边线以外方向多压指定值的宽度。

                    ">右边道路间隙</div>
                    <div class="itemRight">
                        <div class='companyShow'>M</div>
                        <el-input v-if="isLook" class="infoShow" v-model="workSetInfoValue.normalParam.rightGap.value"></el-input>
                        <span v-if="!isLook" class="infoShow">{{workSetInfoValue.normalParam.rightGap.value}}</span>
                    </div>
                </div>
                <div class="item_type">
                    <div class="itemLeft">是否开启泊车功能</div>
                    <div class="itemRight">
                        <!-- <el-input v-if="isLook" class="infoShow" v-model="workSetInfoValue.normalParam.useParking.value"></el-input> -->
                        <el-select v-if="isLook" v-model="workSetInfoValue.normalParam.useParking.value" placeholder="请选择"  class="infoShow">
                            <el-option
                            v-for="item in booleanList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                        <span v-if="!isLook" class="infoShow">{{booleanList[workSetInfoValue.normalParam.useParking.value].label}}</span>
                    </div>
                </div>
                <div class="item_type">
                    <div class="itemLeft">泊车策略</div>
                    <div class="itemRight">
                        <!-- <el-input v-if="isLook" class="infoShow" v-model="workSetInfoValue.normalParam.useParking.value"></el-input> -->
                        <el-select v-if="isLook" v-model="workSetInfoValue.normalParam.strategyForParking.value" placeholder="请选择"  class="infoShow">
                            <el-option
                            v-for="item in workSetInfoValue.strategyForParkingList"
                            :key="parseInt(item[0])"
                            :label="item[1]"
                            :value="parseInt(item[0])">
                            </el-option>
                        </el-select>
                        <span v-if="!isLook" class="infoShow">{{workSetInfoValue.normalParam.strategyForParking.chooseEnum[workSetInfoValue.normalParam.strategyForParking.value]}}</span>
                    </div>
                </div>
            </div>
            <div class="blockItem">
                <div class="item_type">
                    <div class="itemLeft" title="
                    是：承接上次施工进度进行本次施工
否：清空上次施工进度进行本次施工
                    ">承接上次施工进度</div>
                    <div class="itemRight">
                        <!-- <el-input v-if="isLook" class="infoShow" v-model="workSetInfoValue.normalParam.loadLastC0.value"></el-input> -->
                        <el-select v-if="isLook" v-model="workSetInfoValue.normalParam.loadLastC0.value" placeholder="请选择"  class="infoShow">
                            <el-option
                            v-for="item in booleanList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                        <span v-if="!isLook" class="infoShow">{{booleanList[workSetInfoValue.normalParam.loadLastC0.value].label}}</span>
                    </div>
                </div>
                <div class="item_type"></div>
                <div class="item_type"></div>
                <div class="item_type"></div>
            </div>
        </div>
    </div>
    <div class="currency">
        <div class="header"><span class="hText">压实工艺参数</span></div>
        <div class="content">
            <div class="setBlock" style="height:320px">
                <div class="setItem">
                    <div class="redBlock"></div>
                    <div class="headerText">初压设置</div>
                    <el-image
                     class="imgShow"
                    :src="url"
                    ></el-image>
                    <div class="imgShow_type">
                        <div class="item_type1">
                            <div class="itemLeft" title="
                            类型1，则表示严格按照重叠域宽度设定下，道路左右线密度一致，即右侧会多出一些空隙
类型2，则表示严格按照重叠域宽度设定下，道路左线密度大于右侧，即左侧多规划一条路径
类型3，则表示严格按照重叠域宽度设定下，道路右线密度大于左侧，即右侧多规划一条路径
类型4，则表示稀疏型线密度，即拉伸重叠域宽度来填补间隙；
类型5，则表示紧凑型线密度，即压缩重叠域宽度来填补间隙；
类型6，则表示稀疏型线密度，即拉伸中间的重叠宽度来填补间隙，左右侧不存在间隙
类型7，则表示稀疏型线密度，即拉伸中间的重叠宽度来填补间隙，指定左右的间隙长度
                            ">选择碾压密度</div>
                            <div class="itemRight">
                                <!-- <el-input v-if="isLook" class="infoShow" v-model="workSetInfoValue.rollerParam2nd.useAutoSecondRollModel.value"></el-input> -->
                                <el-select v-if="isLook" v-model="workSetInfoValue.rollerParam1st.initialStageRollingDensity.value" placeholder="请选择"  class="infoShow">
                                    <el-option
                                    v-for="item in rollingDensity"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                    </el-option>
                                </el-select>
                                <span v-if="!isLook" class="infoShow">{{rollingDensity[workSetInfoValue.rollerParam1st.initialStageRollingDensity.value].label}}</span>
                            </div>
                        </div>
                        <div class="item_type1">
                            <div class="itemLeft" title="
                            只能选2、3、7
类型2，则表示严格按照重叠域宽度设定下，道路左线密度大于右侧，即左侧多规划一条路径
类型3，则表示严格按照重叠域宽度设定下，道路右线密度大于左侧，即右侧多规划一条路径
类型7，则表示稀疏型线密度，即拉伸中间的重叠宽度来填补间隙，指定左右的间隙长度
                            ">选择左侧贴边方式</div>
                            <div class="itemRight">
                                <!-- <el-input v-if="isLook" class="infoShow" v-model="workSetInfoValue.rollerParam2nd.useAutoSecondRollModel.value"></el-input> -->
                                <el-select v-if="isLook" v-model="workSetInfoValue.rollerParam1st.initialStageLeftBoundaryType.value" placeholder="请选择"  class="infoShow">
                                    <el-option
                                    v-for="item in rollingDensity"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                    </el-option>
                                </el-select>
                                <span v-if="!isLook" class="infoShow">{{rollingDensity[workSetInfoValue.rollerParam1st.initialStageLeftBoundaryType.value].label}}</span>
                            </div>
                        </div>
                        <div class="item_type1">
                            <div class="itemLeft" title="
                            只能选2、3、7
类型2，则表示严格按照重叠域宽度设定下，道路左线密度大于右侧，即左侧多规划一条路径
类型3，则表示严格按照重叠域宽度设定下，道路右线密度大于左侧，即右侧多规划一条路径
类型7，则表示稀疏型线密度，即拉伸中间的重叠宽度来填补间隙，指定左右的间隙长度
                            ">选择右侧贴边方式</div>
                            <div class="itemRight">
                                <!-- <el-input v-if="isLook" class="infoShow" v-model="workSetInfoValue.rollerParam2nd.useAutoSecondRollModel.value"></el-input> -->
                                <el-select v-if="isLook" v-model="workSetInfoValue.rollerParam1st.initialStageRightBoundaryType.value" placeholder="请选择"  class="infoShow">
                                    <el-option
                                    v-for="item in rollingDensity"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                    </el-option>
                                </el-select>
                                <span v-if="!isLook" class="infoShow">{{rollingDensity[workSetInfoValue.rollerParam1st.initialStageRightBoundaryType.value].label}}</span>
                            </div>
                        </div>  
                    </div>
                </div>
                <div style="flex:3">
                    <div style="width:100%;height:90px;margin-top:30px;display:flex">
                        <div style="flex:1">
                            <div class="item_type">
                                <div class="itemLeft" title="
                                否：不进行初压
是：进行初压
                                ">是否开启自动初压</div>
                                <div class="itemRight">
                                    <!-- <el-input v-if="isLook" class="infoShow" v-model="workSetInfoValue.rollerParam2nd.useAutoSecondRollModel.value"></el-input> -->
                                    <el-select v-if="isLook" v-model="workSetInfoValue.rollerParam1st.useAutoInitialRollModel.value" placeholder="请选择"  class="infoShow">
                                        <el-option
                                        v-for="item in booleanList"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                        </el-option>
                                    </el-select>
                                    <span v-if="!isLook" class="infoShow">{{booleanList[workSetInfoValue.rollerParam1st.useAutoInitialRollModel.value].label}}</span>
                                </div>
                            </div>
                            <div class="item_type">
                                <div class="itemLeft">重叠域宽度</div>
                                <div class="itemRight">
                                    <div class='companyShow'>M</div>
                                    <el-input v-if="isLook" class="infoShow" v-model="workSetInfoValue.rollerParam1st.initialStageWidthWrap.value"></el-input>
                                    <span v-if="!isLook" class="infoShow">{{workSetInfoValue.rollerParam1st.initialStageWidthWrap.value}}</span>
                                </div>
                            </div>
                            <div class="item_type">
                                <div class="itemLeft">后退速度</div>
                                <div class="itemRight">
                                    <div class='companyShow'>km/h</div>
                                    <el-input v-if="isLook" class="infoShow" v-model="workSetInfoValue.rollerParam1st.initialStageRollerBackSpeed.value"></el-input>
                                    <span v-if="!isLook" class="infoShow">{{workSetInfoValue.rollerParam1st.initialStageRollerBackSpeed.value}}</span>
                                </div>
                            </div>
                            <div class="item_type">
                                <div class="itemLeft" title="在所有路径上均一来一回才算一遍">初压遍数</div>
                                <div class="itemRight">
                                    <!-- <el-input v-if="isLook" class="infoShow" v-model="workSetInfoValue.rollerParam2nd.fRTimesStr"></el-input> -->
                                    <div v-if="isLook">
                                        <el-select @change="changeRoll1Order" v-model="firstRoll_1" placeholder="请选择"  class="infoShowShot">
                                            <el-option
                                                v-for="item in rollNumList"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </div>
                                    <span v-if="!isLook" class="infoShow">{{rollNumList[workSetInfoValue.rollerParam1st.initialStageRollingNum.value].label}}</span>
                                </div>
                            </div>
                        </div>
                        <div style="flex:1">
                            <div class="item_type">
                                <div class="itemLeft">左边道路间隙</div>
                                <div class="itemRight">
                                    <div class='companyShow'>m</div>
                                    <el-input v-if="isLook" class="infoShow" v-model="workSetInfoValue.rollerParam1st.initialStageLeftPathGap.value"></el-input>
                                    <span v-if="!isLook" class="infoShow">{{workSetInfoValue.rollerParam1st.initialStageLeftPathGap.value}}</span>
                                </div>
                            </div>
                            <div class="item_type">
                                <div class="itemLeft">分区搭接距离</div>
                                <div class="itemRight">
                                    <div class='companyShow'>m</div>
                                    <el-input v-if="isLook" class="infoShow" v-model="workSetInfoValue.rollerParam1st.initialStageAreaOverlap.value"></el-input>
                                    <span v-if="!isLook" class="infoShow">{{workSetInfoValue.rollerParam1st.initialStageAreaOverlap.value}}</span>
                                </div>
                            </div>
                            <div class="item_type">
                                <div class="itemLeft">前进最小速度</div>
                                <div class="itemRight">
                                    <div class='companyShow'>km/h</div>
                                    <el-input v-if="isLook" class="infoShow" v-model="workSetInfoValue.rollerParam1st.initialStageRollerForwardMinSpeed.value"></el-input>
                                    <span v-if="!isLook" class="infoShow">{{workSetInfoValue.rollerParam1st.initialStageRollerForwardMinSpeed.value}}</span>
                                </div>
                            </div>
                            <div class="item_type">
                                <div class="itemLeft">前后轮震动方式</div>
                                <div class="itemRight">
                                    <!-- <el-input v-if="isLook" class="infoShow" v-model="workSetInfoValue.rollerParam1st.initialStageFrontCraftSetting.chooseEnum[workSetInfoValue.rollerParam1st.initialStageFrontCraftSetting.value]"></el-input> -->
                                    <el-select v-if="isLook" v-model="workSetInfoValue.rollerParam1st.initialStageCraftType.value" placeholder="请选择"  class="infoShow">
                                        <el-option
                                            v-for="item in stageCraftType"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value">
                                        </el-option>
                                    </el-select>
                                    <span v-if="!isLook" class="infoShow">{{stageCraftType[workSetInfoValue.rollerParam1st.initialStageCraftType.value].label}}</span>
                                </div> 
                            </div>
                        </div>
                        <div style="flex:1">
                            <div class="item_type">
                                <div class="itemLeft">右边道路间隙</div>
                                <div class="itemRight">
                                    <div class='companyShow'>m</div>
                                    <el-input v-if="isLook" class="infoShow" v-model="workSetInfoValue.rollerParam1st.initialStageRightPathGap.value"></el-input>
                                    <span v-if="!isLook" class="infoShow">{{workSetInfoValue.rollerParam1st.initialStageRightPathGap.value}}</span>
                                </div>
                            </div>
                            <div class="item_type">
                                <div class="itemLeft">选择初压压路机</div>
                                <div class="itemRight">
                                    <span v-if="!isLook" class="infoShow">{{workSetInfoValue.equipCodeRoller1ndStr}}</span>
                                    <el-select v-if="isLook" v-model="equipCodeRoller1nd" placeholder="请选择"  class="infoShow" multiple collapse-tags>
                                        <el-option
                                            v-for="item in equipmentList"
                                            :key="item.code"
                                            :label="item.name"
                                            :value="item.code">
                                        </el-option>
                                    </el-select>
                                </div>
                            </div>
                            <div class="item_type">
                                <div class="itemLeft">前进最大速度</div>
                                <div class="itemRight">
                                    <div class='companyShow'>km/h</div>
                                    <el-input v-if="isLook" class="infoShow" v-model="workSetInfoValue.rollerParam1st.initialStageRollerForwardMaxSpeed.value"></el-input>
                                    <span v-if="!isLook" class="infoShow">{{workSetInfoValue.rollerParam1st.initialStageRollerForwardMaxSpeed.value}}</span>
                                </div>
                            </div>
                        </div>
                    </div>    
                    <div style="width:100%;height:90px;marginTop:120px;">
                        <div style="flex:1">
                            <div class="item_type">
                                <div class="itemLeft">振动序列</div>
                                <div class="itemRight">
                                    <div v-if="!isLook">
                                        <!-- <span  class="orderShow" v-for="(item,index) in workSetInfoValue.rollerParam1st.fRTimesArr"  :key='index'>{{item}}</span> -->
                                        <span  class="orderShow1" v-for="(item,index) in firstStageRollOrderArrFont"  :key='index'>
                                            <span v-for="(i,k) in item" :key='k'>
                                                <span>{{i}}<span>{{k==0?" | ":""}}</span></span>
                                            </span>
                                        </span>
                                    </div>
                                    
                                    <div v-if="isLook">
                                        <draggable v-model="firstStageRollOrderArr" @update="datadragEndf" v-bind = "{draggable:'.drag-item',animation:500}">
                                                <transition-group>
                                                    <div v-for="(element,i) in firstStageRollOrderArr" :key="i+1" class = "drag-item">
                                                        <div class="dragitemselect">
                                                            <el-select @change="changeRollShak1Order(i,0)" v-model="firstStageRollOrderArr[i][0]" placeholder="请选择"  class="infoShowShot">
                                                                <el-option
                                                                    v-for="item in forwardCraftSettingList"
                                                                    :key="item.value"
                                                                    :label="item.label"
                                                                    :value="item.value">
                                                                </el-option>
                                                            </el-select>|
                                                            <el-select @change="changeRollShak1Order(i,1)" v-model="firstStageRollOrderArr[i][1]" placeholder="请选择"  class="infoShowShot">
                                                                <el-option
                                                                    v-for="item in backCraftSettingList"
                                                                    :key="item.value"
                                                                    :label="item.label"
                                                                    :value="item.value">
                                                                </el-option>
                                                            </el-select>
                                                        </div>
                                                    </div>
                                                </transition-group>
                                        </draggable>
                                    </div>
                                        
                                </div>
                            </div>
                        </div>
                    </div>
                </div>    
            </div>
            <div class="line"></div>
            <div class="setBlock" style="height:320px">
                <div class="setItem">
                    <div class="redBlock"></div>
                    <div class="headerText">复压设置</div>
                    <el-image
                     class="imgShow"
                    :src="url"
                    ></el-image>
                    <div class="imgShow_type">
                        <div class="item_type1">
                            <div class="itemLeft" title="
                            类型1，则表示严格按照重叠域宽度设定下，道路左右线密度一致，即右侧会多出一些空隙
类型2，则表示严格按照重叠域宽度设定下，道路左线密度大于右侧，即左侧多规划一条路径
类型3，则表示严格按照重叠域宽度设定下，道路右线密度大于左侧，即右侧多规划一条路径
类型4，则表示稀疏型线密度，即拉伸重叠域宽度来填补间隙；
类型5，则表示紧凑型线密度，即压缩重叠域宽度来填补间隙；
类型6，则表示稀疏型线密度，即拉伸中间的重叠宽度来填补间隙，左右侧不存在间隙
类型7，则表示稀疏型线密度，即拉伸中间的重叠宽度来填补间隙，指定左右的间隙长度
                            ">选择碾压密度</div>
                            <div class="itemRight">
                                <!-- <el-input v-if="isLook" class="infoShow" v-model="workSetInfoValue.rollerParam2nd.useAutoSecondRollModel.value"></el-input> -->
                                <el-select v-if="isLook" v-model="workSetInfoValue.rollerParam2nd.secondStageRollingDensity.value" placeholder="请选择"  class="infoShow">
                                    <el-option
                                    v-for="item in rollingDensity"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                    </el-option>
                                </el-select>
                                <span v-if="!isLook" class="infoShow">{{rollingDensity[workSetInfoValue.rollerParam2nd.secondStageRollingDensity.value].label}}</span>
                            </div>
                        </div>
                        <div class="item_type1">
                            <div class="itemLeft" title="
                            只能选2、3、7
类型2，则表示严格按照重叠域宽度设定下，道路左线密度大于右侧，即左侧多规划一条路径
类型3，则表示严格按照重叠域宽度设定下，道路右线密度大于左侧，即右侧多规划一条路径
类型7，则表示稀疏型线密度，即拉伸中间的重叠宽度来填补间隙，指定左右的间隙长度
                            ">选择左侧贴边方式</div>
                            <div class="itemRight">
                                <!-- <el-input v-if="isLook" class="infoShow" v-model="workSetInfoValue.rollerParam2nd.useAutoSecondRollModel.value"></el-input> -->
                                <el-select v-if="isLook" v-model="workSetInfoValue.rollerParam2nd.secondStageLeftBoundaryType.value" placeholder="请选择"  class="infoShow">
                                    <el-option
                                    v-for="item in rollingDensity"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                    </el-option>
                                </el-select>
                                <span v-if="!isLook" class="infoShow">{{rollingDensity[workSetInfoValue.rollerParam2nd.secondStageLeftBoundaryType.value].label}}</span>
                            </div>
                        </div>
                        <div class="item_type1">
                            <div class="itemLeft" title="
                            只能选2、3、7
类型2，则表示严格按照重叠域宽度设定下，道路左线密度大于右侧，即左侧多规划一条路径
类型3，则表示严格按照重叠域宽度设定下，道路右线密度大于左侧，即右侧多规划一条路径
类型7，则表示稀疏型线密度，即拉伸中间的重叠宽度来填补间隙，指定左右的间隙长度
                            ">选择右侧贴边方式</div>
                            <div class="itemRight">
                                <!-- <el-input v-if="isLook" class="infoShow" v-model="workSetInfoValue.rollerParam2nd.useAutoSecondRollModel.value"></el-input> -->
                                <el-select v-if="isLook" v-model="workSetInfoValue.rollerParam2nd.secondStageRightBoundaryType.value" placeholder="请选择"  class="infoShow">
                                    <el-option
                                    v-for="item in rollingDensity"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                    </el-option>
                                </el-select>
                                <span v-if="!isLook" class="infoShow">{{rollingDensity[workSetInfoValue.rollerParam2nd.secondStageRightBoundaryType.value].label}}</span>
                            </div>
                        </div>  
                    </div>
                </div>
                <div style="flex:3">
                    <div style="width:100%;height:90px;margin-top:30px;display:flex">
                        <div style="flex:1">
                            <div class="item_type">
                                <div class="itemLeft" title="
                                否：不自动从初压区域中提取复压区域；
是：自动从初压区域中提取复压区域并自动完成复压（需在自动碾压模式中分别预先设定初、复压设备）
                                ">是否开启自动复压</div>
                                <div class="itemRight">
                                    <!-- <el-input v-if="isLook" class="infoShow" v-model="workSetInfoValue.rollerParam2nd.useAutoSecondRollModel.value"></el-input> -->
                                    <el-select v-if="isLook" v-model="workSetInfoValue.rollerParam2nd.useAutoSecondRollModel.value" placeholder="请选择"  class="infoShow">
                                        <el-option
                                        v-for="item in booleanList"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                        </el-option>
                                    </el-select>
                                    <span v-if="!isLook" class="infoShow">{{booleanList[workSetInfoValue.rollerParam2nd.useAutoSecondRollModel.value].label}}</span>
                                </div>
                            </div>
                            <div class="item_type">
                                <div class="itemLeft">重叠域宽度</div>
                                <div class="itemRight">
                                    <div class='companyShow'>M</div>
                                    <el-input v-if="isLook" class="infoShow" v-model="workSetInfoValue.rollerParam2nd.secondStageWidthWrap.value"></el-input>
                                    <span v-if="!isLook" class="infoShow">{{workSetInfoValue.rollerParam2nd.secondStageWidthWrap.value}}</span>
                                </div>
                            </div>
                            <div class="item_type">
                                <div class="itemLeft"  title="在所有路径上均一来一回才算一遍">复压遍数</div>
                                <div class="itemRight">
                                    <!-- <el-input v-if="isLook" class="infoShow" v-model="workSetInfoValue.rollerParam2nd.fRTimesStr"></el-input> -->
                                    <div v-if="isLook">
                                        <el-select @change="changeRoll2Order" v-model="secondRoll_1" placeholder="请选择"  class="infoShowShot">
                                            <el-option
                                                v-for="item in rollNumList"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </div>
                                    <span v-if="!isLook" class="infoShow">{{rollNumList[workSetInfoValue.rollerParam2nd.secondStageRollingNum.value].label}}</span>
                                </div>
                            </div>
                        </div>
                        <div style="flex:1">
                            <div class="item_type">
                                <div class="itemLeft">左边道路间隙</div>
                                <div class="itemRight">
                                    <div class='companyShow'>m</div>
                                    <el-input v-if="isLook" class="infoShow" v-model="workSetInfoValue.rollerParam2nd.secondStageLeftPathGap.value"></el-input>
                                    <span v-if="!isLook" class="infoShow">{{workSetInfoValue.rollerParam2nd.secondStageLeftPathGap.value}}</span>
                                </div>
                            </div>
                            <div class="item_type">
                                <div class="itemLeft">分区搭接距离</div>
                                <div class="itemRight">
                                    <div class='companyShow'>m</div>
                                    <el-input v-if="isLook" class="infoShow" v-model="workSetInfoValue.rollerParam2nd.secondStageAreaOverlap.value"></el-input>
                                    <span v-if="!isLook" class="infoShow">{{workSetInfoValue.rollerParam2nd.secondStageAreaOverlap.value}}</span>
                                </div>
                            </div>
                            <div class="item_type">
                                <div class="itemLeft">复压速度</div>
                                <div class="itemRight">
                                    <div class='companyShow'>km/h</div>
                                    <el-input v-if="isLook" class="infoShow" v-model="workSetInfoValue.rollerParam2nd.secondStageRollerSpeed.value"></el-input>
                                    <span v-if="!isLook" class="infoShow">{{workSetInfoValue.rollerParam2nd.secondStageRollerSpeed.value}}</span>
                                </div>
                            </div>
                        </div>
                        <div style="flex:1">
                            <div class="item_type">
                                <div class="itemLeft">右边道路间隙</div>
                                <div class="itemRight">
                                    <div class='companyShow'>m</div>
                                    <el-input v-if="isLook" class="infoShow" v-model="workSetInfoValue.rollerParam2nd.secondStageRightPathGap.value"></el-input>
                                    <span v-if="!isLook" class="infoShow">{{workSetInfoValue.rollerParam2nd.secondStageRightPathGap.value}}</span>
                                </div>
                            </div>
                            <div class="item_type">
                                <div class="itemLeft">选择复压压路机</div>
                                <div class="itemRight">
                                    <span v-if="!isLook" class="infoShow">{{workSetInfoValue.equipCodeRoller2ndStr}}</span>
                                    <el-select v-if="isLook" v-model="equipCodeRoller2nd" placeholder="请选择"  class="infoShow" multiple collapse-tags>
                                        <el-option
                                            v-for="item in equipmentList"
                                            :key="item.code"
                                            :label="item.name"
                                            :value="item.code">
                                        </el-option>
                                    </el-select>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style="width:100%;height:90px;marginTop:70px;">
                        <div style="flex:1">
                            <div class="item_type">
                                <div class="itemLeft">振动序列</div>
                                <div class="itemRight">
                                    <div v-if="!isLook">
                                        <span  class="orderShow1" v-for="(item,index) in secondStageRollOrderArrFont"  :key='index'>
                                            <span v-for="(i,k) in item" :key='k'>
                                                <span>{{i}}<span>{{k==0?" | ":""}}</span></span>
                                            </span>
                                        </span>
                                    </div>
                                    
                                    <div v-if="isLook">
                                        <draggable v-model="secondStageRollOrderArr" @update="datadragEnd" v-bind = "{draggable:'.drag-item',animation:500}">
                                                <transition-group>
                                                    <div v-for="(element,i) in secondStageRollOrderArr" :key="i+1" class = "drag-item">
                                                        <div class="dragitemselect">
                                                            <el-select @change="changeRollShak2Order(i,0)" v-model="secondStageRollOrderArr[i][0]" placeholder="请选择"  class="infoShowShot">
                                                                <el-option
                                                                    v-for="item in forwardCraftSettingList"
                                                                    :key="item.value"
                                                                    :label="item.label"
                                                                    :value="item.value">
                                                                </el-option>
                                                            </el-select>|
                                                            <el-select @change="changeRollShak2Order(i,1)" v-model="secondStageRollOrderArr[i][1]" placeholder="请选择"  class="infoShowShot">
                                                                <el-option
                                                                    v-for="item in backCraftSettingList"
                                                                    :key="item.value"
                                                                    :label="item.label"
                                                                    :value="item.value">
                                                                </el-option>
                                                            </el-select>
                                                        </div>
                                                    </div>
                                                </transition-group>
                                        </draggable>
                                    </div>
                                        
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="line"></div>
            <div class="setBlock" style="height:320px">
                <div class="setItem">
                    <div class="redBlock"></div>
                    <div class="headerText">终压设置</div>
                    <el-image
                     class="imgShow"
                    :src="url"
                    ></el-image>
                    <div class="imgShow_type">
                        <div class="item_type1">
                            <div class="itemLeft" title="
                            类型1，则表示严格按照重叠域宽度设定下，道路左右线密度一致，即右侧会多出一些空隙
类型2，则表示严格按照重叠域宽度设定下，道路左线密度大于右侧，即左侧多规划一条路径
类型3，则表示严格按照重叠域宽度设定下，道路右线密度大于左侧，即右侧多规划一条路径
类型4，则表示稀疏型线密度，即拉伸重叠域宽度来填补间隙；
类型5，则表示紧凑型线密度，即压缩重叠域宽度来填补间隙；
类型6，则表示稀疏型线密度，即拉伸中间的重叠宽度来填补间隙，左右侧不存在间隙
类型7，则表示稀疏型线密度，即拉伸中间的重叠宽度来填补间隙，指定左右的间隙长度
                            ">选择碾压密度</div>
                            <div class="itemRight">
                                <!-- <el-input v-if="isLook" class="infoShow" v-model="workSetInfoValue.rollerParam2nd.useAutoSecondRollModel.value"></el-input> -->
                                <el-select v-if="isLook" v-model="workSetInfoValue.rollerParam3rd.thirdStageRollingDensity.value" placeholder="请选择"  class="infoShow">
                                    <el-option
                                    v-for="item in rollingDensity"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                    </el-option>
                                </el-select>
                                <span v-if="!isLook" class="infoShow">{{rollingDensity[workSetInfoValue.rollerParam3rd.thirdStageRollingDensity.value].label}}</span>
                            </div>
                        </div>
                        <div class="item_type1">
                            <div class="itemLeft" title="
                            只能选2、3、7
类型2，则表示严格按照重叠域宽度设定下，道路左线密度大于右侧，即左侧多规划一条路径
类型3，则表示严格按照重叠域宽度设定下，道路右线密度大于左侧，即右侧多规划一条路径
类型7，则表示稀疏型线密度，即拉伸中间的重叠宽度来填补间隙，指定左右的间隙长度
                            ">选择左侧贴边方式</div>
                            <div class="itemRight">
                                <!-- <el-input v-if="isLook" class="infoShow" v-model="workSetInfoValue.rollerParam2nd.useAutoSecondRollModel.value"></el-input> -->
                                <el-select v-if="isLook" v-model="workSetInfoValue.rollerParam3rd.thirdStageLeftBoundaryType.value" placeholder="请选择"  class="infoShow">
                                    <el-option
                                    v-for="item in rollingDensity"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                    </el-option>
                                </el-select>
                                <span v-if="!isLook" class="infoShow">{{rollingDensity[workSetInfoValue.rollerParam3rd.thirdStageLeftBoundaryType.value].label}}</span>
                            </div>
                        </div>
                        <div class="item_type1">
                            <div class="itemLeft" title="
                            只能选2、3、7
类型2，则表示严格按照重叠域宽度设定下，道路左线密度大于右侧，即左侧多规划一条路径
类型3，则表示严格按照重叠域宽度设定下，道路右线密度大于左侧，即右侧多规划一条路径
类型7，则表示稀疏型线密度，即拉伸中间的重叠宽度来填补间隙，指定左右的间隙长度
                            ">选择右侧贴边方式</div>
                            <div class="itemRight">
                                <!-- <el-input v-if="isLook" class="infoShow" v-model="workSetInfoValue.rollerParam2nd.useAutoSecondRollModel.value"></el-input> -->
                                <el-select v-if="isLook" v-model="workSetInfoValue.rollerParam3rd.thirdStageRightBoundaryType.value" placeholder="请选择"  class="infoShow">
                                    <el-option
                                    v-for="item in rollingDensity"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                    </el-option>
                                </el-select>
                                <span v-if="!isLook" class="infoShow">{{rollingDensity[workSetInfoValue.rollerParam3rd.thirdStageRightBoundaryType.value].label}}</span>
                            </div>
                        </div>  
                    </div>
                </div>
                <div style="flex:3">
                    <div style="width:100%;height:90px;margin-top:30px;display:flex">
                        <div style="flex:1">
                            <div class="item_type">
                                <div class="itemLeft" title="
                                否：不自动从复压区域中提取终压区域；
是：自动从复压区域中提取终压区域并自动完成终压（需在自动碾压模式中分别预先设定初、复压设备）
                                ">是否开启自动终压</div>
                                <div class="itemRight">
                                    <!-- <el-input v-if="isLook" class="infoShow" v-model="workSetInfoValue.rollerParam3rd.useAutoThirdRollModel.value"></el-input> -->
                                    <el-select v-if="isLook" v-model="workSetInfoValue.rollerParam3rd.useAutoThirdRollModel.value" placeholder="请选择"  class="infoShow">
                                        <el-option
                                        v-for="item in booleanList"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                        </el-option>
                                    </el-select>
                                    <span v-if="!isLook" class="infoShow">{{booleanList[workSetInfoValue.rollerParam3rd.useAutoThirdRollModel.value].label}}</span>
                                </div>
                            </div>
                            <div class="item_type">
                                <div class="itemLeft">重叠域宽度</div>
                                <div class="itemRight">
                                    <div class='companyShow'>M</div>
                                    <el-input v-if="isLook" class="infoShow" v-model="workSetInfoValue.rollerParam3rd.thirdStageWidthWrap.value"></el-input>
                                    <span v-if="!isLook" class="infoShow">{{workSetInfoValue.rollerParam3rd.thirdStageWidthWrap.value}}</span>
                                </div>
                            </div>
                            <div class="item_type">
                                <div class="itemLeft" title="在所有路径上均一来一回才算一遍">终压遍数</div>
                                <div class="itemRight" style="">
                                    <!-- <el-input v-if="isLook" class="infoShow" v-model="workSetInfoValue.rollerParam3rd.zRTimesStr"></el-input> -->
                                    <div v-if="isLook">
                                        <el-select @change="changeRoll3Order" v-model="thirdRoll_1" placeholder="请选择"  class="infoShowShot">
                                            <el-option
                                                v-for="item in rollNumList"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </div>
                                    <span v-if="!isLook" class="infoShow">{{rollNumList[workSetInfoValue.rollerParam3rd.thirdStageRollingNum.value].label}}</span>
                                </div>
                            </div>
                        </div>
                        <div style="flex:1">
                            <div class="item_type">
                                <div class="itemLeft">左边道路间隙</div>
                                <div class="itemRight">
                                    <div class='companyShow'>m</div>
                                    <el-input v-if="isLook" class="infoShow" v-model="workSetInfoValue.rollerParam3rd.thirdStageLeftPathGap.value"></el-input>
                                    <span v-if="!isLook" class="infoShow">{{workSetInfoValue.rollerParam3rd.thirdStageLeftPathGap.value}}</span>
                                </div>
                            </div>
                            <div class="item_type">
                                <div class="itemLeft">分区搭接距离</div>
                                <div class="itemRight">
                                    <div class='companyShow'>m</div>
                                    <el-input v-if="isLook" class="infoShow" v-model="workSetInfoValue.rollerParam3rd.thirdStageAreaOverlap.value"></el-input>
                                    <span v-if="!isLook" class="infoShow">{{workSetInfoValue.rollerParam3rd.thirdStageAreaOverlap.value}}</span>
                                </div>
                            </div>
                            <div class="item_type">
                                <div class="itemLeft">终压速度</div>
                                <div class="itemRight">
                                    <div class='companyShow'>km/h</div>
                                    <el-input v-if="isLook" class="infoShow" v-model="workSetInfoValue.rollerParam3rd.thirdStageRollerSpeed.value"></el-input>
                                    <span v-if="!isLook" class="infoShow">{{workSetInfoValue.rollerParam3rd.thirdStageRollerSpeed.value}}</span>
                                </div>
                            </div>
                        </div>
                        <div style="flex:1">
                            <div class="item_type">
                                <div class="itemLeft">右边道路间隙</div>
                                <div class="itemRight">
                                    <div class='companyShow'>m</div>
                                    <el-input v-if="isLook" class="infoShow" v-model="workSetInfoValue.rollerParam3rd.thirdStageRightPathGap.value"></el-input>
                                    <span v-if="!isLook" class="infoShow">{{workSetInfoValue.rollerParam3rd.thirdStageRightPathGap.value}}</span>
                                </div>
                            </div>
                            <div class="item_type">
                                <div class="itemLeft">选择终压压路机</div>
                                <div class="itemRight">
                                    <span v-if="!isLook" class="infoShow">{{workSetInfoValue.equipCodeRoller3ndStr}}</span>
                                    <el-select v-if="isLook" v-model="equipCodeRoller3nd" placeholder="请选择"  class="infoShow" multiple collapse-tags>
                                        <el-option
                                            v-for="item in equipmentList"
                                            :key="item.code"
                                            :label="item.name"
                                            :value="item.code">
                                        </el-option>
                                    </el-select>
                                </div>
                            </div>
                            
                        </div>
                    </div>
                    <div style="width:100%;height:90px;marginTop:70px;">
                        <div style="flex:1">
                            <div class="item_type">
                                <div class="itemLeft">振动序列</div>
                                <div class="itemRight">
                                    <!-- <el-input v-if="isLook" class="infoShow" v-model="workSetInfoValue.rollerParam3rd.secondStageRollOrder.value"></el-input> -->
                                    <div v-if="!isLook">
                                        <!-- <span class="orderShow" v-for="(item,index) in workSetInfoValue.rollerParam3rd.zRTimesArr"  :key='index'>{{item}}</span> -->
                                        <span  class="orderShow1" v-for="(item,index) in thirdStageRollOrderArrFont"  :key='index'>
                                            <span v-for="(i,k) in item" :key='k'>
                                                <span>{{i}}<span>{{k==0?" | ":""}}</span></span>
                                            </span>
                                        </span>
                                    </div>
                                    
                                    <div v-if="isLook">
                                        <draggable v-model="thirdStageRollOrderArr" @update="datadragEndT" v-bind = "{draggable:'.drag-item',animation:500}">
                                                <transition-group>
                                                    <div v-for="(element,i) in thirdStageRollOrderArr" :key="i+1" class = "drag-item">
                                                        <div class="dragitemselect">
                                                            <el-select @change="changeRollShak3Order(i,0)" v-model="thirdStageRollOrderArr[i][0]" placeholder="请选择"  class="infoShowShot">
                                                                <el-option
                                                                    v-for="item in forwardCraftSettingList"
                                                                    :key="item.value"
                                                                    :label="item.label"
                                                                    :value="item.value">
                                                                </el-option>
                                                            </el-select>|
                                                            <el-select @change="changeRollShak3Order(i,1)" v-model="thirdStageRollOrderArr[i][1]" placeholder="请选择"  class="infoShowShot">
                                                                <el-option
                                                                    v-for="item in backCraftSettingList"
                                                                    :key="item.value"
                                                                    :label="item.label"
                                                                    :value="item.value">
                                                                </el-option>
                                                            </el-select>
                                                        </div>
                                                    </div>
                                                </transition-group>
                                        </draggable>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
            </div>
        </div>
    </div>

    <div class="currency">
        <div class="header"><span class="hText">摊铺工艺参数</span></div>
        <div class="content">
            <div class="setBlock" style="height: 230px;">
                <div class="setItem">
                    <!-- <image class="imgShow_pav" src="../../images/all/setImg.png" /> -->
                    <el-image
                     class="imgShow_pav"
                    :src="url"
                    ></el-image>
                </div>
                <div class="setItem" style="padding-top:20px">
                    <div class="item_type">
                        <div class="itemLeft">搭接距离</div>
                        <div class="itemRight">
                            <div class='companyShow'>m</div>
                            <el-input v-if="isLook" class="infoShow" v-model="workSetInfoValue.paverParam.paverOverlap.value"></el-input>
                            <span v-if="!isLook" class="infoShow">{{workSetInfoValue.paverParam.paverOverlap.value}}</span>
                        </div>
                    </div>
                    <div class="item_type">
                        <div class="itemLeft" title="用于摊铺机集群进度自适应">是否开启速度自适应</div>
                        <div class="itemRight">
                            <!-- <el-input v-if="isLook" class="infoShow" v-model="workSetInfoValue.normalParam.useParking.value"></el-input> -->
                            <el-select v-if="isLook" v-model="workSetInfoValue.paverParam.paverIsOpenAdaption.value" placeholder="请选择"  class="infoShow">
                                <el-option
                                v-for="item in booleanList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                            </el-select>
                            <span v-if="!isLook" class="infoShow">{{booleanList[workSetInfoValue.paverParam.paverIsOpenAdaption.value].label}}</span>
                        </div>
                    </div>
                    <div class="item_type">
                        <div class="itemLeft">最低行驶速度</div>
                        <div class="itemRight">
                            <div class='companyShow'>m/min</div>
                            <el-input v-if="isLook" class="infoShow" v-model="workSetInfoValue.paverParam.paverSpeedMinimum.value"></el-input>
                            <span v-if="!isLook" class="infoShow">{{workSetInfoValue.paverParam.paverSpeedMinimum.value}}</span>
                        </div>
                    </div>
                    <div class="item_type">
                        <div class="itemLeft" title="单位：m，可用于左侧熨平板临时伸缩，影响初压跟踪效果">左侧附加物长度</div>
                        <div class="itemRight">
                            <div class='companyShow'>m</div>
                            <el-input v-if="isLook" class="infoShow" v-model="workSetInfoValue.paverParam.paverLeftAdditiaonalLength.value"></el-input>
                            <span v-if="!isLook" class="infoShow">{{workSetInfoValue.paverParam.paverLeftAdditiaonalLength.value}}</span>
                        </div>
                    </div>
                </div>
                <div class="setItem" style="padding-top:20px">
                    <div class="item_type">
                        <div class="itemLeft">左边道路间隙</div>
                        <div class="itemRight">
                            <div class='companyShow'>m</div>
                            <el-input v-if="isLook" class="infoShow" v-model="workSetInfoValue.paverParam.leftGap4Paver.value"></el-input>
                            <span v-if="!isLook" class="infoShow">{{workSetInfoValue.paverParam.leftGap4Paver.value}}</span>
                        </div>
                    </div>
                    <div class="item_type">
                        <div class="itemLeft">起步速度</div>
                        <div class="itemRight">
                            <div class='companyShow'>m/min</div>
                            <el-input v-if="isLook" class="infoShow" v-model="workSetInfoValue.paverParam.paverStartSpeed.value"></el-input>
                            <span v-if="!isLook" class="infoShow">{{workSetInfoValue.paverParam.paverStartSpeed.value}}</span>
                        </div>
                    </div>
                    <div class="item_type">
                        <div class="itemLeft">最高行驶速度</div>
                        <div class="itemRight">
                            <div class='companyShow'>m/min</div>
                            <el-input v-if="isLook" class="infoShow" v-model="workSetInfoValue.paverParam.paverSpeedMaximum.value"></el-input>
                            <span v-if="!isLook" class="infoShow">{{workSetInfoValue.paverParam.paverSpeedMaximum.value}}</span>
                        </div>
                    </div>
                    <div class="item_type">
                        <div class="itemLeft" title="单位：m，可用于右侧熨平板伸缩，影响初压跟踪效果">右侧附加物长度</div>
                        <div class="itemRight">
                            <div class='companyShow'>m</div>
                            <el-input v-if="isLook" class="infoShow" v-model="workSetInfoValue.paverParam.paverRightAdditiaonalLength.value"></el-input>
                            <span v-if="!isLook" class="infoShow">{{workSetInfoValue.paverParam.paverRightAdditiaonalLength.value}}</span>
                        </div>
                    </div>
                </div>
                <div class="setItem" style="padding-top:20px">
                    <div class="item_type">
                        <div class="itemLeft">右边道路间隙</div>
                        <div class="itemRight">
                            <div class='companyShow'>m</div>
                            <el-input v-if="isLook" class="infoShow" v-model="workSetInfoValue.paverParam.rightGap4Paver.value"></el-input>
                            <span v-if="!isLook" class="infoShow">{{workSetInfoValue.paverParam.rightGap4Paver.value}}</span>
                        </div>
                    </div>
                    <div class="item_type">
                        <div class="itemLeft">选择摊铺机</div>
                        <div class="itemRight">
                            <span v-if="!isLook" class="infoShow">{{workSetInfoValue.equipCodePaverStr}}</span>
                            <el-select v-if="isLook" v-model="equipCodePaver" placeholder="请选择"  class="infoShow" multiple collapse-tags>
                                <el-option
                                    v-for="item in equipmentList"
                                    :key="item.code"
                                    :label="item.name"
                                    :value="item.code">
                                </el-option>
                            </el-select>
                        </div>
                    </div>
                    <div class="item_type">
                        <div class="itemLeft">最佳行驶速度</div>
                        <div class="itemRight">
                            <div class='companyShow'>m/min</div>
                            <el-input v-if="isLook" class="infoShow" v-model="workSetInfoValue.paverParam.paverOptimumSpeed.value"></el-input>
                            <span v-if="!isLook" class="infoShow">{{workSetInfoValue.paverParam.paverOptimumSpeed.value}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
    //   import { getWorkConfig,getWorkConfigDetails } from '../../utils/api'
    import draggable from 'vuedraggable'
    export default {
        name: 'app',
        data() {
            return {
                url: require('../../images/all/setImg.png'),
                // 通用判断列表
                booleanList: [{
                    label: '否',
                    value: 0
                }, {
                    label: '是',
                    value: 1
                }],
                // 震动模式
                craftSettingList: [{
                    label: '静压',
                    value: 0
                }, {
                    label: '小震',
                    value: 1
                }, {
                    label: '大震',
                    value: 2
                }],
                // 前进震动模式
                forwardCraftSettingList: [{
                    label: '前进静压',
                    value: 0
                }, {
                    label: '前进小震',
                    value: 1
                }, {
                    label: '前进大震',
                    value: 2
                }],
                // 后退震动模式
                backCraftSettingList: [{
                    label: '后退静压',
                    value: 0
                }, {
                    label: '后退小震',
                    value: 1
                }, {
                    label: '后退大震',
                    value: 2
                }],
                //前后轮震动方式
                stageCraftType: [{
                    label: '前轮震动',
                    value: 0
                }, {
                    label: '后轮震动',
                    value: 1
                }, {
                    label: '前后轮震动',
                    value: 2
                }],
                //贴边方式
                rollingDensity: [{
                    label: '类型1：右侧留空',
                    value: 0
                }, {
                    label: '类型2：左侧多压',
                    value: 1
                }, {
                    label: '类型3：右侧多压',
                    value: 2
                }, {
                    label: '类型4：稀疏型',
                    value: 3
                }, {
                    label: '类型5：紧凑型',
                    value: 4
                }, {
                    label: '类型6：稀疏型(无间隙)',
                    value: 5
                }, {
                    label: '类型7：稀疏型(指定间隙)',
                    value: 6
                }],
                // 前进震动数组
                forwardCraftSettingListArr: ['前进静压', '前进小震', '前进大震'],
                // 后退震动数组
                backCraftSettingListArr: ['后退静压', '后退小震', '后退大震'],
                craftSettingObj: {
                    0: '静压',
                    1: '小震',
                    2: '大震',
                },
                //遍数
                rollNumList: [{
                    label: '无',
                    value: 0
                }, {
                    label: '一遍',
                    value: 1
                }, {
                    label: '二遍',
                    value: 2
                }, {
                    label: '三遍',
                    value: 3
                }, {
                    label: '四遍',
                    value: 4
                }, {
                    label: '五遍',
                    value: 5
                }, {
                    label: '六遍',
                    value: 6
                }, {
                    label: '七遍',
                    value: 7
                }, {
                    label: '八遍',
                    value: 8
                }, ],
                firstRoll_1: 1,
                secondRoll_1: 1,
                // secondRoll_2: 1,
                // secondRoll_3: 1,
                thirdRoll_1: 1,
                // thirdRoll_2: 1,
                // thirdRoll_3: 1,
                // 泊车策略
                strategyForParkingList: [],
                // 整体数据
                workSetInfoValue: this.workSetInfo,

                startArr: [],
                endArr: [],
                count: 0,
                firstStageRollOrderArr: [], //碾压顺序文字数组
                secondStageRollOrderArr: [],
                thirdStageRollOrderArr: [],
                firstStageRollOrderNumArr: [], //碾压顺序数字数组
                secondStageRollOrderNumArr: [],
                thirdStageRollOrderNumArr: [],
                firstStageRollOrderArrFont: [], //用于展示数组
                secondStageRollOrderArrFont: [],
                thirdStageRollOrderArrFont: [],

                equipCodeRoller1nd: [],
                equipCodeRoller2nd: [],
                equipCodeRoller3nd: [],
                equipCodePaver: []
            }
        },
        props: {
            workSetInfo: {
                type: Object,
                default: function() {
                    return {
                        workSetInfo: {}
                    }
                }
            },
            equipmentList: {
                type: Array,
                default: function() {
                    return []
                }
            },
            isLook: {
                type: Boolean,
                required: false
            },
            setParameterChange: {
                type: String
            },
        },
        computed: {},
        beforeCreate() {

        },
        created() {
            console.log('jinlai')
            document.body.ondrop = function(event) {
                event.preventDefault();
                event.stopPropagation();
            }
        },
        mounted() {
            this.firstStageRollOrderArr = [], //碾压顺序文字数组
                this.secondStageRollOrderArr = [],
                this.thirdStageRollOrderArr = [],
                this.firstStageRollOrderArrFont = [], //用于展示数组
                this.secondStageRollOrderArrFont = [],
                this.thirdStageRollOrderArrFont = [],

                this.firstRoll_1 = this.workSetInfoValue.rollerParam1st.initialStageRollingNum.value * 1
            this.secondRoll_1 = this.workSetInfoValue.rollerParam2nd.secondStageRollingNum.value * 1
            this.thirdRoll_1 = this.workSetInfoValue.rollerParam3rd.thirdStageRollingNum.value * 1

            this.firstStageRollOrderNumArr = this.workSetInfoValue.rollerParam1st.initialStageRollingOrder.value.split(",").map(item => item * 1)
            this.secondStageRollOrderNumArr = this.workSetInfoValue.rollerParam2nd.secondStageRollingOrder.value.split(",").map(item => item * 1)
            this.thirdStageRollOrderNumArr = this.workSetInfoValue.rollerParam3rd.thirdStageRollingOrder.value.split(",").map(item => item * 1)

            for (let i = 0; i < this.firstStageRollOrderNumArr.length; i++) {
                if (i % 2 == 0) {
                    this.firstStageRollOrderArr.push([this.firstStageRollOrderNumArr[i]])
                    this.firstStageRollOrderArrFont.push([this.forwardCraftSettingListArr[this.firstStageRollOrderNumArr[i]]])
                } else {
                    this.firstStageRollOrderArr[parseInt(i / 2)].push(this.firstStageRollOrderNumArr[i])
                    this.firstStageRollOrderArrFont[parseInt(i / 2)].push(this.backCraftSettingListArr[this.firstStageRollOrderNumArr[i]])
                }
            }
            for (let i = 0; i < this.secondStageRollOrderNumArr.length; i++) {
                if (i % 2 == 0) {
                    this.secondStageRollOrderArr.push([this.secondStageRollOrderNumArr[i]])
                    this.secondStageRollOrderArrFont.push([this.forwardCraftSettingListArr[this.secondStageRollOrderNumArr[i]]])
                } else {
                    this.secondStageRollOrderArr[parseInt(i / 2)].push(this.secondStageRollOrderNumArr[i])
                    this.secondStageRollOrderArrFont[parseInt(i / 2)].push(this.backCraftSettingListArr[this.secondStageRollOrderNumArr[i]])
                }
            }
            for (let i = 0; i < this.thirdStageRollOrderNumArr.length; i++) {
                if (i % 2 == 0) {
                    this.thirdStageRollOrderArr.push([this.thirdStageRollOrderNumArr[i]])
                    this.thirdStageRollOrderArrFont.push([this.forwardCraftSettingListArr[this.thirdStageRollOrderNumArr[i]]])
                } else {
                    this.thirdStageRollOrderArr[parseInt(i / 2)].push(this.thirdStageRollOrderNumArr[i])
                    this.thirdStageRollOrderArrFont[parseInt(i / 2)].push(this.backCraftSettingListArr[this.thirdStageRollOrderNumArr[i]])
                }
            }

            console.log(this.workSetInfoValue)
        },
        methods: {
            getdata(evt) {
                console.log(evt.draggedContext.element.text)
            },
            datadragEndf(evt) {
                evt.preventDefault();
                console.log('拖动前的索引 :' + evt.oldIndex)
                console.log('拖动后的索引 :' + evt.newIndex)
                console.log(this.firstStageRollOrderArr);
                let arr = []
                for (let i = 0; i < this.firstStageRollOrderArr.length; i++) {
                    for (let j = 0; j < this.firstStageRollOrderArr[i].length; j++) {
                        arr.push(this.firstStageRollOrderArr[i][j])
                    }
                }
                this.firstStageRollOrderNumArr = arr
                console.log(arr)
            },
            datadragEnd(evt) {
                evt.preventDefault();
                console.log('拖动前的索引 :' + evt.oldIndex)
                console.log('拖动后的索引 :' + evt.newIndex)
                console.log(this.secondStageRollOrderArr);
                let arr = []
                for (let i = 0; i < this.secondStageRollOrderArr.length; i++) {
                    for (let j = 0; j < this.secondStageRollOrderArr[i].length; j++) {
                        arr.push(this.secondStageRollOrderArr[i][j])
                    }
                }
                this.secondStageRollOrderNumArr = arr
                console.log(arr)
            },
            datadragEndT(evt) {
                evt.preventDefault();
                let arr = []
                for (let i = 0; i < this.thirdStageRollOrderArr.length; i++) {
                    for (let j = 0; j < this.thirdStageRollOrderArr[i].length; j++) {
                        arr.push(this.thirdStageRollOrderArr[i][j])
                    }
                }
                this.thirdStageRollOrderNumArr = arr
                console.log(arr)
            },
            checkArray: function(para, arr) {
                let processArr = arr.filter(function(value) {
                    return value == para;
                });
                return processArr.length; // 这里返回数组长度或者相应处理
            },
            changeRollShak1Order(i, num) {
                console.log(i, num)
                let arr = []
                for (let i = 0; i < this.firstStageRollOrderArr.length; i++) {
                    for (let j = 0; j < this.firstStageRollOrderArr[i].length; j++) {
                        arr.push(this.firstStageRollOrderArr[i][j])
                    }
                }
                this.firstStageRollOrderNumArr = arr
            },
            changeRollShak2Order(i, num) {
                console.log(i, num)
                let arr = []
                for (let i = 0; i < this.secondStageRollOrderArr.length; i++) {
                    for (let j = 0; j < this.secondStageRollOrderArr[i].length; j++) {
                        arr.push(this.secondStageRollOrderArr[i][j])
                    }
                }
                this.secondStageRollOrderNumArr = arr
            },
            changeRollShak3Order(i, num) {
                console.log(i, num)
                let arr = []
                for (let i = 0; i < this.thirdStageRollOrderArr.length; i++) {
                    for (let j = 0; j < this.thirdStageRollOrderArr[i].length; j++) {
                        arr.push(this.thirdStageRollOrderArr[i][j])
                    }
                }
                this.thirdStageRollOrderNumArr = arr
            },
            changeRoll1Order: function() {
                let setArr = []
                for (let i = 0; i < this.firstRoll_1; i++) {
                    setArr.push([0, 0])
                }
                this.firstStageRollOrderArr = setArr
                let arr = []
                for (let i = 0; i < this.firstStageRollOrderArr.length; i++) {
                    for (let j = 0; j < this.firstStageRollOrderArr[i].length; j++) {
                        arr.push(this.firstStageRollOrderArr[i][j])
                    }
                }
                this.firstStageRollOrderNumArr = arr
                console.log('specialAreaRollingOrderNumArr:', this.firstStageRollOrderArr)
            },
            changeRoll2Order: function() { //获取碾压顺序的数组
                let setArr = []
                for (let i = 0; i < this.secondRoll_1; i++) {
                    setArr.push([0, 0])
                }
                this.secondStageRollOrderArr = setArr
                let arr = []
                for (let i = 0; i < this.secondStageRollOrderArr.length; i++) {
                    for (let j = 0; j < this.secondStageRollOrderArr[i].length; j++) {
                        arr.push(this.secondStageRollOrderArr[i][j])
                    }
                }
                this.secondStageRollOrderNumArr = arr
                console.log('specialAreaRollingOrderNumArr:', this.secondStageRollOrderArr)
            },
            changeRoll3Order: function() {
                let setArr = []
                for (let i = 0; i < this.thirdRoll_1; i++) {
                    setArr.push([0, 0])
                }
                this.thirdStageRollOrderArr = setArr
                let arr = []
                for (let i = 0; i < this.thirdStageRollOrderArr.length; i++) {
                    for (let j = 0; j < this.thirdStageRollOrderArr[i].length; j++) {
                        arr.push(this.thirdStageRollOrderArr[i][j])
                    }
                }
                this.thirdStageRollOrderNumArr = arr
                console.log('specialAreaRollingOrderNumArr:', this.thirdStageRollOrderArr)
            },
            getEquipName: function(arr1, arr2) {
                let equipCheckList = []
                for (let i = 0; i < arr1.length; i++) {
                    for (let j = 0; j < arr2.length; j++) {
                        if (arr1[i] == arr2[j].code) {
                            equipCheckList.push(arr2[j].name)
                        }
                    }
                }
                let equipCheckStr = equipCheckList.join(",")

                return equipCheckStr
            }
        },
        watch: {
            //   'workSetInfo'(newV){
            //     console.log(newV)
            //     this.secondStageRollOrderArr = newV.secondStageRollOrderArr
            //     this.secondRoll_1= this.checkArray('静压',this.secondStageRollOrderArr),
            //     this.secondRoll_2= this.checkArray('小震',this.secondStageRollOrderArr),
            //     this.secondRoll_3= this.checkArray('大震',this.secondStageRollOrderArr),

            //     this.thirdStageRollOrderArr = newV.thirdStageRollOrderArr
            //     this.thirdRoll_1= this.checkArray('静压',this.thirdStageRollOrderArr),
            //     this.thirdRoll_2= this.checkArray('小震',this.thirdStageRollOrderArr),
            //     this.thirdRoll_3= this.checkArray('大震',this.thirdStageRollOrderArr),
            //     this.workSetInfoValue = newV
            //     this.secondStageRollOrderNumArr = newV.rollerParam2nd.secondStageRollOrder.value.split(",")
            //     this.thirdStageRollOrderNumArr = newV.rollerParam3rd.thirdStageRollOrder.value.split(",")

            //   },
            workSetInfo: {
                deep: true,
                immediate: true,
                handler(newV) {
                    console.log(newV)
                    if (newV.consUnit) {
                        this.workSetInfoValue = newV.paramInfo
                        this.workSetInfoValue.equipCodePaverStr=newV.equipCodePaverStr
                        this.workSetInfoValue.equipCodeRoller1ndStr=newV.equipCodeRoller1ndStr
                        this.workSetInfoValue.equipCodeRoller2ndStr=newV.equipCodeRoller2ndStr
                        this.workSetInfoValue.equipCodeRoller3ndStr=newV.equipCodeRoller3ndStr
                        this.equipCodePaver=newV.equipCodePaver
                        this.equipCodeRoller1nd=newV.equipCodeRoller1st
                        this.equipCodeRoller2nd=newV.equipCodeRoller2nd
                        this.equipCodeRoller3nd=newV.equipCodeRoller3rd
                    } else {
                        this.workSetInfoValue = newV
                    }
                    if(this.workSetInfoValue.equipCodePaverStr){
                        this.equipCodePaver=(this.workSetInfoValue.equipCodePaverStr).split("、")
                        this.equipCodeRoller1nd=(this.workSetInfoValue.equipCodeRoller1ndStr).split("、")
                        this.equipCodeRoller2nd=(this.workSetInfoValue.equipCodeRoller2ndStr).split("、")
                        this.equipCodeRoller3nd=(this.workSetInfoValue.equipCodeRoller3ndStr).split("、")
                    }
                    if (this.workSetInfoValue.setCode=='') {
                        // this.firstStageRollOrderArr = this.workSetInfoValue.rollerParam1st.initialStageRollingOrder
                        // this.firstRoll_1 = this.checkArray('静压', this.firstStageRollOrderArr)

                        // this.secondStageRollOrderArr = this.workSetInfoValue.rollerParam2nd.secondStageRollOrderArr
                        // this.secondRoll_1 = this.checkArray('静压', this.secondStageRollOrderArr)

                        // this.thirdStageRollOrderArr = this.workSetInfoValue.thirdStageRollOrderArr
                        // this.thirdRoll_1 = this.checkArray('静压', this.thirdStageRollOrderArr)
                        // console.log("newVseconde", this.workSetInfoValue)
                        this.firstStageRollOrderArr = [], //碾压顺序文字数组
                            this.secondStageRollOrderArr = [],
                            this.thirdStageRollOrderArr = [],
                            this.firstStageRollOrderArrFont = [], //用于展示数组
                            this.secondStageRollOrderArrFont = [],
                            this.thirdStageRollOrderArrFont = [],
                        this.firstRoll_1 = this.workSetInfoValue.rollerParam1st.initialStageRollingNum.value * 1
                        this.secondRoll_1 = this.workSetInfoValue.rollerParam2nd.secondStageRollingNum.value * 1
                        this.thirdRoll_1 = this.workSetInfoValue.rollerParam3rd.thirdStageRollingNum.value * 1
                        this.firstStageRollOrderNumArr = this.workSetInfoValue.rollerParam1st.initialStageRollingOrder.value.split(",").map(item => item * 1)
                        this.secondStageRollOrderNumArr = this.workSetInfoValue.rollerParam2nd.secondStageRollingOrder.value.split(",").map(item => item * 1)
                        this.thirdStageRollOrderNumArr = this.workSetInfoValue.rollerParam3rd.thirdStageRollingOrder.value.split(",").map(item => item * 1)
                        for (let i = 0; i < this.firstStageRollOrderNumArr.length; i++) {
                            if (i % 2 == 0) {
                                this.firstStageRollOrderArr.push([this.firstStageRollOrderNumArr[i]])
                                this.firstStageRollOrderArrFont.push([this.forwardCraftSettingListArr[this.firstStageRollOrderNumArr[i]]])
                            } else {
                                this.firstStageRollOrderArr[parseInt(i / 2)].push(this.firstStageRollOrderNumArr[i])
                                this.firstStageRollOrderArrFont[parseInt(i / 2)].push(this.backCraftSettingListArr[this.firstStageRollOrderNumArr[i]])
                            }
                        }
                        for (let i = 0; i < this.secondStageRollOrderNumArr.length; i++) {
                            if (i % 2 == 0) {
                                this.secondStageRollOrderArr.push([this.secondStageRollOrderNumArr[i]])
                                this.secondStageRollOrderArrFont.push([this.forwardCraftSettingListArr[this.secondStageRollOrderNumArr[i]]])
                            } else {
                                this.secondStageRollOrderArr[parseInt(i / 2)].push(this.secondStageRollOrderNumArr[i])
                                this.secondStageRollOrderArrFont[parseInt(i / 2)].push(this.backCraftSettingListArr[this.secondStageRollOrderNumArr[i]])
                            }
                        }
                        for (let i = 0; i < this.thirdStageRollOrderNumArr.length; i++) {
                            if (i % 2 == 0) {
                                this.thirdStageRollOrderArr.push([this.thirdStageRollOrderNumArr[i]])
                                this.thirdStageRollOrderArrFont.push([this.forwardCraftSettingListArr[this.thirdStageRollOrderNumArr[i]]])
                            } else {
                                this.thirdStageRollOrderArr[parseInt(i / 2)].push(this.thirdStageRollOrderNumArr[i])
                                this.thirdStageRollOrderArrFont[parseInt(i / 2)].push(this.backCraftSettingListArr[this.thirdStageRollOrderNumArr[i]])
                            }
                        }
                        console.log("newVseconde2", this.workSetInfoValue)
                    }
                    if (newV.setCode == 'init') {
                        console.log('setCodejinlai', newV)
                        this.workSetInfoValue = newV
                            // this.workSetInfoValue.rollerParam2nd = newV.rollerParam2nd
                            // this.workSetInfoValue.rollerParam3rd = newV.rollerParam3rd
                            // 
                        this.firstStageRollOrderArr = [], //碾压顺序文字数组
                            this.secondStageRollOrderArr = [],
                            this.thirdStageRollOrderArr = [],
                            this.firstStageRollOrderArrFont = [], //用于展示数组
                            this.secondStageRollOrderArrFont = [],
                            this.thirdStageRollOrderArrFont = [],

                        this.firstRoll_1 = this.workSetInfoValue.rollerParam1st.initialStageRollingNum.value * 1
                        this.secondRoll_1 = this.workSetInfoValue.rollerParam2nd.secondStageRollingNum.value * 1
                        this.thirdRoll_1 = this.workSetInfoValue.rollerParam3rd.thirdStageRollingNum.value * 1

                        this.firstStageRollOrderNumArr = this.workSetInfoValue.rollerParam1st.initialStageRollingOrder.value.split(",").map(item => item * 1)
                        this.secondStageRollOrderNumArr = this.workSetInfoValue.rollerParam2nd.secondStageRollingOrder.value.split(",").map(item => item * 1)
                        this.thirdStageRollOrderNumArr = this.workSetInfoValue.rollerParam3rd.thirdStageRollingOrder.value.split(",").map(item => item * 1)

                        for (let i = 0; i < this.firstStageRollOrderNumArr.length; i++) {
                            if (i % 2 == 0) {
                                this.firstStageRollOrderArr.push([this.firstStageRollOrderNumArr[i]])
                                this.firstStageRollOrderArrFont.push([this.forwardCraftSettingListArr[this.firstStageRollOrderNumArr[i]]])
                            } else {
                                this.firstStageRollOrderArr[parseInt(i / 2)].push(this.firstStageRollOrderNumArr[i])
                                this.firstStageRollOrderArrFont[parseInt(i / 2)].push(this.backCraftSettingListArr[this.firstStageRollOrderNumArr[i]])
                            }
                        }
                        for (let i = 0; i < this.secondStageRollOrderNumArr.length; i++) {
                            if (i % 2 == 0) {
                                this.secondStageRollOrderArr.push([this.secondStageRollOrderNumArr[i]])
                                this.secondStageRollOrderArrFont.push([this.forwardCraftSettingListArr[this.secondStageRollOrderNumArr[i]]])
                            } else {
                                this.secondStageRollOrderArr[parseInt(i / 2)].push(this.secondStageRollOrderNumArr[i])
                                this.secondStageRollOrderArrFont[parseInt(i / 2)].push(this.backCraftSettingListArr[this.secondStageRollOrderNumArr[i]])
                            }
                        }
                        for (let i = 0; i < this.thirdStageRollOrderNumArr.length; i++) {
                            if (i % 2 == 0) {
                                this.thirdStageRollOrderArr.push([this.thirdStageRollOrderNumArr[i]])
                                this.thirdStageRollOrderArrFont.push([this.forwardCraftSettingListArr[this.thirdStageRollOrderNumArr[i]]])
                            } else {
                                this.thirdStageRollOrderArr[parseInt(i / 2)].push(this.thirdStageRollOrderNumArr[i])
                                this.thirdStageRollOrderArrFont[parseInt(i / 2)].push(this.backCraftSettingListArr[this.thirdStageRollOrderNumArr[i]])
                            }
                        }

                    }

                }

            },

            setParameterChange(newV) {
                console.log(newV)
                let equipAllList = []
                equipAllList = equipAllList.concat(this.equipCodePaver)
                equipAllList = equipAllList.concat(this.equipCodeRoller1nd)
                equipAllList = equipAllList.concat(this.equipCodeRoller2nd)
                equipAllList = equipAllList.concat(this.equipCodeRoller3nd)
                let equipCheckStr = this.getEquipName(equipAllList, this.equipmentList)
                let equipCodePaverStr = this.getEquipName(this.equipCodePaver, this.equipmentList)
                let equipCodeRoller1ndStr = this.getEquipName(this.equipCodeRoller1nd, this.equipmentList)
                let equipCodeRoller2ndStr = this.getEquipName(this.equipCodeRoller2nd, this.equipmentList)
                let equipCodeRoller3ndStr = this.getEquipName(this.equipCodeRoller3nd, this.equipmentList)

                this.workSetInfoValue.rollerParam1st.initialStageRollingNum.value = this.firstRoll_1
                this.workSetInfoValue.rollerParam2nd.secondStageRollingNum.value = this.secondRoll_1
                this.workSetInfoValue.rollerParam3rd.thirdStageRollingNum.value = this.thirdRoll_1

                this.workSetInfoValue.rollerParam1st.initialStageRollingOrder.value = this.firstStageRollOrderNumArr.join(",")
                this.workSetInfoValue.rollerParam2nd.secondStageRollingOrder.value = this.secondStageRollOrderNumArr.join(",")
                this.workSetInfoValue.rollerParam3rd.thirdStageRollingOrder.value = this.thirdStageRollOrderNumArr.join(",")

                console.log(this.firstStageRollOrderNumArr)
                console.log(this.secondStageRollOrderNumArr)
                console.log(this.thirdStageRollOrderNumArr)
                let params = {
                    equipCodeRoller1nd: this.equipCodeRoller1nd,
                    equipCodeRoller2nd: this.equipCodeRoller2nd,
                    equipCodeRoller3nd: this.equipCodeRoller3nd,
                    equipCodePaver: this.equipCodePaver,
                    workSetInfoValue: this.workSetInfoValue,
                    equipCheckStr: equipCheckStr,
                    equipCodePaverStr: equipCodePaverStr,
                    equipCodeRoller1ndStr: equipCodeRoller1ndStr,
                    equipCodeRoller2ndStr: equipCodeRoller2ndStr,
                    equipCodeRoller3ndStr: equipCodeRoller3ndStr,
                    initialStageRollingOrder: this.firstStageRollOrderNumArr.join(","),
                    secondStageRollOrderArr: this.secondStageRollOrderNumArr.join(","),
                    thirdStageRollOrderArr: this.thirdStageRollOrderNumArr.join(",")
                }
                console.log(params)
                this.$emit("childFun5", params)
            }
        },
        components: {
            draggable
        }
    }
</script>
<style lang="scss">
    .currency {
        .el-input__inner {
            padding-right: 40px !important;
        }
        .infoShow {
            width: 100%;
            height: 100%;
            border: 0;
            color: #555555;
            font-size: 14px;
            // padding-left: 46px;
        }
    }
    
    .selectShort {
        width: 254px !important;
    }
    
    .dragitemselect {
        display: flex;
        justify-content: center;
        border: 1px solid #222222;
        border-radius: 20px !important;
        >div {
            margin-left: 0px !important;
            margin-right: 0px !important;
        }
        .el-input__suffix {
            display: none !important;
            border-radius: 20px !important;
        }
        .el-input__inner {
            padding: 0px !important;
            text-align: center;
            border: none !important;
            border-radius: 0px !important;
            height: 34px !important;
            width: 66px !important;
        }
    }
</style>
<style lang="scss" scoped="">
    .currency {
        width: 100%;
        height: auto;
        margin-top: 14px;
        // background-color: aqua;
        border: 1px solid rgba(225, 225, 225, 1);
    }
    
    .header {
        width: 100%;
        height: 50px;
        background: rgba(242, 242, 245, 1);
        border-bottom: 1px solid rgba(225, 225, 225, 1);
        position: relative;
        .hText {
            display: inline-block;
            position: absolute;
            line-height: 17px;
            height: 17px;
            font-size: 16px;
            color: 16px;
            top: 17px;
            left: 16px;
            font-weight: bold;
            color: rgba(85, 85, 85, 1);
        }
    }
    
    .content {
        width: 95%;
        height: auto;
    }
    
    .line {
        height: 1px;
        width: 94.5%;
        margin: 0 auto;
        background-color: #E1E1E1;
    }
    .item_type {height:50px}
    .setBlock {
        display: flex;
        height: 212px;
        width: 100%;
        .item_type {
            flex: 1;
            .itemLeft {
                width: 144px;
                height: 45px;
                float: left;
                line-height: 45px;
                text-align: right;
                color: #888888;
                font-size: 13px;
            }
            .itemRight {
                height: 100%;
                height: 45px;
                line-height: 45px;
                padding-left: 39px;
                overflow: hidden;
                color: #222222;
                font-size: 14px;
                position: relative;
                .orderShow {
                    display: inline-block;
                    width: 45px;
                    height: 22px;
                    background: rgba(225, 235, 250, 1);
                    font-size: 14px;
                    color: #2273F8;
                    text-align: center;
                    line-height: 22px;
                    margin-left: 6px;
                }
                .orderShow1 {
                    display: inline-block;
                    width:150px;
                    height:36px;
                    // background:rgba(225,235,250,1);
                    font-size:14px;
                    border-radius: 18px;
                    // color: #2273F8;
                    text-align: center;
                    line-height: 36px;
                    margin-left: 6px;
                    border: 1px solid #222;
                    margin-right: 12px;
                }
                .companyShow {
                    font-size: 14px;
                    color: #222222;
                    width: 40px;
                    line-height: 45px;
                    height: 45px;
                    text-align: center;
                    position: absolute;
                    top: 0;
                    right: 0;
                    z-index: 100;
                }
                .infoShowShot {
                    width: 90px;
                    margin-left: 8px;
                    margin-right: 8px;
                }
            }
        }
        .setItem {
            flex: 1;
            position: relative;
            padding-top: 30px;
            .item_type {
                height:50px;
                flex: 1;
                .itemLeft {
                    width: 144px;
                    height: 45px;
                    float: left;
                    line-height: 45px;
                    text-align: right;
                    color: #888888;
                    font-size: 13px;
                }
                .itemRight {
                    height: 100%;
                    height: 45px;
                    line-height: 45px;
                    padding-left: 39px;
                    overflow: hidden;
                    color: #222222;
                    font-size: 14px;
                    position: relative;
                    .companyShow {
                        font-size: 14px;
                        color: #222222;
                        width: 40px;
                        line-height: 45px;
                        height: 45px;
                        text-align: center;
                        position: absolute;
                        top: 0;
                        right: 0;
                        z-index: 100;
                    }
                    .infoShow {
                        width: 100%;
                        height: 100%;
                        border: 0;
                        color: #555555;
                        font-size: 14px;
                        // padding-left: 46px;
                    }
                }
            }
            .redBlock {
                height: 18px;
                width: 4px;
                position: absolute;
                background-color: #E96B5A;
                top: 23px;
                left: 52px;
            }
            .headerText {
                height: 14px;
                line-height: 14px;
                color: #555555;
                display: inline-block;
                position: absolute;
                top: 25px;
                left: 64px;
                font-weight: 600;
                font-size: 14px;
            }
            .imgShow {
                width: 227px;
                height: 135px;
                position: absolute;
                top: 59px;
                left: 52px;
                background-image: url("../../images/all/setImg.png");
                background-color: #E96B5A;
            }
            .imgShow_type {
                width: 100%;
                height: 135px;
                position: absolute;
                top: 200px;
                left: 10px;
                .item_type1 {
                    flex: 1;
                    .itemLeft {
                        width: 144px;
                        height: 40px;
                        float: left;
                        line-height: 40px;
                        text-align: right;
                        color: #888888;
                        font-size: 13px;
                    }
                    .itemRight {
                        height: 100%;
                        height: 40px;
                        line-height: 40px;
                        padding-left: 39px;
                        overflow: hidden;
                        color: #222222;
                        font-size: 14px;
                        position: relative;
                        .companyShow {
                            font-size: 14px;
                            color: #222222;
                            width: 40px;
                            line-height: 40px;
                            height: 40px;
                            text-align: center;
                            position: absolute;
                            top: 0;
                            right: 0;
                            z-index: 100;
                        }
                        .infoShow {
                            width: 100%;
                            height: 100%;
                            border: 0;
                            color: #555555;
                            font-size: 14px;
                            // padding-left: 46px;
                        }
                    }
                }
            }
            
            .imgShow_pav {
                width: 223px;
                height: 178px;
                position: absolute;
                top: 26px;
                left: 54px;
                background-image: url("../../images/all/setImg.png");
            }
        }
    }
    
    .blockItem {
        display: flex;
        height: 57px;
        .item_type {
            flex: 1;
            .itemLeft {
                width: 144px;
                height: 57px;
                float: left;
                line-height: 57px;
                text-align: right;
                color: #888888;
                font-size: 13px;
            }
            .itemRight {
                height: 100%;
                height: 57px;
                line-height: 57px;
                font-size: 14px;
                overflow: hidden;
                color: #222222;
                position: relative;
                .companyShow {
                    font-size: 14px;
                    color: #222222;
                    width: 40px;
                    line-height: 57px;
                    height: 57px;
                    text-align: center;
                    position: absolute;
                    top: 0;
                    right: 0;
                    z-index: 100;
                }
                .infoShow {
                    width: 100%;
                    height: 100%;
                    border: 0;
                    color: #555555;
                    font-size: 14px;
                    padding-left: 46px;
                }
            }
        }
    }
    
    .test {
        border: 1px solid #ccc;
    }
    
    .drag-item {
        width: 180px;
        height: 36px;
        line-height: 36px;
        text-align: center;
        // background: #E1EBFA;
        color: #2273F8;
        margin-right: 12px;
        margin-top: 3px;
        cursor: pointer;
        float: left;
    }
    
    .ghostClass {
        opacity: 1;
    }
    
    .bottom {
        width: 200px;
        height: 50px;
        position: relative;
        background: blue;
        top: 2px;
        left: 2px;
        transition: all .5s linear;
    }
</style>
<style lang="scss">
    .currency {
        .el-input__inner {
            padding-right: 40px !important;
        }
        .infoShow {
            width: 100%;
            height: 100%;
            border: 0;
            color: #555555;
            font-size: 14px;
            // padding-left: 46px;
        }
    }
</style>